export default "__VITE_ASSET__CmRTCQ57__"